// src/features/reabertura/components/ReaberturaAuditList.jsx
import React from "react";

function formatDateTimeBR(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const nn = String(d.getMinutes()).padStart(2, "0");
  return `${dd}/${mm}/${yyyy} ${hh}:${nn}`;
}

export default function ReaberturaAuditList({ audit = [] }) {
  return (
    <>
      <div className="mb-2 flex items-center gap-2 text-white/80">
        <span aria-hidden>🕘</span>
        <h2 className="text-sm font-medium">Auditoria</h2>
      </div>

      {audit.length === 0 ? (
        <div className="rounded-xl border border-white/10 bg-white/5 p-4 text-white/70">
          Nenhuma reabertura realizada ainda.
        </div>
      ) : (
        <ul className="space-y-2">
          {audit.map((a) => (
            <li
              key={a.id}
              className="rounded-xl border border-white/10 bg-white/5 p-3 text-sm"
            >
              <div className="flex flex-wrap items-center gap-2">
                <span aria-hidden>✅</span>
                <span className="text-white/90">{a.actor || "—"}</span>
                <span className="text-white/60">reabriu</span>
                <span className="font-mono text-emerald-200">
                  {(a.ids || []).join(", ")}
                </span>
                <span className="text-white/60">em</span>
                <span className="text-white/80">{formatDateTimeBR(a.when)}</span>
              </div>

              <div className="mt-1 text-white/80">
                <span className="text-white/60">Motivo:</span> {a.reason}
              </div>

              {a.summary ? (
                <div className="mt-1 text-white/70">
                  <span className="text-white/60">Resultado:</span> {a.summary}
                </div>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
